<div>
  <mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>PARAM&Eacute;TRE ACTION</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <mat-card class="example-card carClass">
        <mat-card-content>
          <form class="example-form" #f="ngForm">
            <div class="btn">
              <span  class="button-row">
                <button type="submit" [disabled]="!exist" (click)="ajouter(f)" mat-raised-button                  class="colorGreen">
                  <mat-icon>add</mat-icon>
                  Ajouter</button>
              </span>
              <span  class="button-row">
                <button type="button" [disabled]="!exist" (click)="modifier(f)" mat-raised-button
                  class="colorBlue"><mat-icon>edite</mat-icon>Modifier</button>
              </span>
              <span class="button-row">
                <button type="button" [disabled]="!exist" (click)="supprimer()" mat-raised-button
                  class="colorRed"><mat-icon>delete</mat-icon>Supprimer</button>
              </span>
            </div>
            <mat-form-field     appearance="outline"  style="width: 70px;">
              <mat-label>Code</mat-label>
              <input disabled="true" matInput name="avtParamAction_Code" #avtParamAction_Code="ngModel"
                [(ngModel)]="data.avtParamAction_Code" placeholder="Code" required>
            </mat-form-field>

            <mat-form-field     appearance="outline"  style="width: 300px;">
              <mat-label>Déscription</mat-label>
              <input matInput name="avtParamAction_Description" #avtParamAction_Description="ngModel"
                [(ngModel)]="data.avtParamAction_Description" placeholder="Déscription" required>
            </mat-form-field>
            <mat-checkbox name="avtParamAction_Facture" [(ngModel)]="data.avtParamAction_Facture">Facturable
            </mat-checkbox>
            <span (click)="showColor('btn-color-action')" class="color-action" [style.background]="data.avtParamAction_ColorAction" [style.color]="data.avtParamAction_ColorText">
              Couleur action
            </span>
            <input id="btn-color-action" type="button" value="Choisir">
            <span (click)="showColor('btn-color-text')" class="color-action" [style.background]="data.avtParamAction_ColorAction" [style.color]="data.avtParamAction_ColorText">
              Couleur Text
            </span>
            <input id="btn-color-text" type="button" value="Choisir">
            <mat-form-field     appearance="outline"  style="margin-left: 10px;">
              <mat-label>Type actions</mat-label>
              <mat-select placeholder="Type actions" name="avtTypeActions" [(ngModel)]="data.avtParamAction_Default" required>
                <mat-option *ngFor="let type of typeAction" [value]="type.value">{{type.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </mat-card-content>
      </mat-card>
      <mat-card class="example-card carClass">
        <mat-card-content>
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="avtParamAction_Code">
              <th mat-header-cell *matHeaderCellDef> Code </th>
              <td mat-cell *matCellDef="let element"> {{element.avtParamAction_Code}} </td>
            </ng-container>
            <ng-container matColumnDef="avtParamAction_Description">
              <th mat-header-cell *matHeaderCellDef>Désignation </th>
              <td mat-cell *matCellDef="let element"> {{element.avtParamAction_Description}} </td>
            </ng-container>
            <!-- <ng-container matColumnDef="avtParamAction_Public">
              <th mat-header-cell *matHeaderCellDef> Public </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Public"></mat-checkbox>
              </td>
            </ng-container> -->
            <ng-container matColumnDef="avtParamAction_Facture">
              <th mat-header-cell *matHeaderCellDef> Facturable </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Facture"></mat-checkbox>
              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="avtParamAction_Presence">
              <th mat-header-cell *matHeaderCellDef> Présence </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Presence"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="avtParamAction_Client">
              <th mat-header-cell *matHeaderCellDef> Client</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Client"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="avtParamAction_Hotel">
              <th mat-header-cell *matHeaderCellDef> Hotél </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Hotel"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="avtParamAction_Repas">
              <th mat-header-cell *matHeaderCellDef> Repas </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Repas"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="avtParamAction_Info">
              <th mat-header-cell *matHeaderCellDef> Information </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Info"></mat-checkbox>
              </td>
            </ng-container>
            
            <ng-container matColumnDef="avtParamAction_Opsolet">
              <th mat-header-cell *matHeaderCellDef> Opsolét </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox disabled="true" [ngModel]="element.avtParamAction_Opsolet"></mat-checkbox>
              </td>
            </ng-container> -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef> Type  </th>
              <td mat-cell *matCellDef="let element">
                 {{element.action}}
              </td>
            </ng-container>
            <ng-container matColumnDef="avtParamAction_Color">
              <th mat-header-cell *matHeaderCellDef> Couleur </th>
              <td mat-cell *matCellDef="let element">
                <span [style.background]="element.avtParamAction_ColorAction"
                  [style.color]="element.avtParamAction_ColorText">Couleur</span>

            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow($event,row)"></tr>
          </table>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>